export interface AtokuStatusPillConfig {
    label: string;
    chipClass: string;
    icon: string;
    outlined?: boolean;
}

const SUBSCRIPTION_STATE_PILLS: Record<'subscribed' | 'suspended' | 'NaN', AtokuStatusPillConfig> = {
    subscribed: {
        label: 'Subscribed',
        chipClass: 'success-chip',
        icon: 'check_circle'
    },
    suspended: {
        label: 'Suspended',
        chipClass: 'warn-chip',
        icon: 'pause_circle'
    },
    NaN: {
        label: 'NaN',
        chipClass: 'disabled-chip na-pill',
        icon: 'remove_circle'
    }
};

const BLOCKED_STATE_PILLS: Record<'blocked' | 'active' | 'NaN', AtokuStatusPillConfig> = {
    blocked: {
        label: 'Blocked',
        chipClass: 'error-chip',
        icon: 'block'
    },
    active: {
        label: 'Active',
        chipClass: 'success-chip',
        icon: 'check_circle'
    },
    NaN: {
        label: 'NaN',
        chipClass: 'disabled-chip na-pill',
        icon: 'remove_circle'
    }
};

const ENTRY_STATUS_PILLS: Record<'granted' | 'denied', AtokuStatusPillConfig> = {
    granted: {
        label: 'Granted',
        chipClass: 'success-chip',
        icon: 'check_circle'
    },
    denied: {
        label: 'Denied',
        chipClass: 'error-chip',
        icon: 'cancel'
    }
};

const LEASE_STATUS_PILLS: Record<string, AtokuStatusPillConfig> = {
    active: {
        label: 'Active',
        chipClass: 'success-chip',
        icon: 'check_circle'
    },
    paid: {
        label: 'Paid',
        chipClass: 'success-chip',
        icon: 'paid'
    },
    awaitingpayment: {
        label: 'Awaiting Payment',
        chipClass: 'warn-chip',
        icon: 'schedule'
    },
    expired: {
        label: 'Expired',
        chipClass: 'disabled-chip',
        icon: 'timer_off'
    },
    terminated: {
        label: 'Terminated',
        chipClass: 'error-chip',
        icon: 'cancel'
    },
    cancelled: {
        label: 'Cancelled',
        chipClass: 'error-chip',
        icon: 'cancel'
    },
    blocked: {
        label: 'Blocked',
        chipClass: 'error-chip',
        icon: 'block'
    }
};

export function getSubscriptionStatusPill(state: 'subscribed' | 'suspended' | 'NaN'): AtokuStatusPillConfig {
    return SUBSCRIPTION_STATE_PILLS[state] ?? SUBSCRIPTION_STATE_PILLS.NaN;
}

export function getBlockedStatusPill(blocked: boolean | null): AtokuStatusPillConfig {
    if (blocked === null) {
        return BLOCKED_STATE_PILLS.NaN;
    }
    return blocked ? BLOCKED_STATE_PILLS.blocked : BLOCKED_STATE_PILLS.active;
}

export function getEntryStatusPill(status: 'granted' | 'denied'): AtokuStatusPillConfig {
    return ENTRY_STATUS_PILLS[status] ?? ENTRY_STATUS_PILLS.granted;
}

export function getLeaseStatusPill(status: string | null | undefined): AtokuStatusPillConfig {
    const value = String(status ?? '').trim();
    const key = value.toLowerCase().replace(/[^a-z0-9]/g, '');
    return LEASE_STATUS_PILLS[key] ?? {
        label: value || 'NaN',
        chipClass: 'disabled-chip na-pill',
        icon: 'remove_circle'
    };
}
